import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Set from "@babel/runtime-corejs3/core-js-stable/set";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/splice";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import React, { useContext, useState } from 'react';
import classNames from 'classnames';
import List from './list';
import Operation from './operation';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import noDataImg from './img/transfer-empty.png';

var Transfer = function Transfer(props) {
  var _classNames;

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      userDefaultProps = _useContext.compDefaultProps,
      locale = _useContext.locale;

  var transferProps = getCompProps('Transfer', userDefaultProps, props); // 获取穿梭框props

  var customPrefixcls = transferProps.prefixCls,
      className = transferProps.className,
      dataSource = transferProps.dataSource,
      _transferProps$target = transferProps.targetKeys,
      targetKeys = _transferProps$target === void 0 ? [] : _transferProps$target,
      _transferProps$select = transferProps.selectedKeys,
      selectedKeys = _transferProps$select === void 0 ? [] : _transferProps$select,
      disabled = transferProps.disabled,
      render = transferProps.render,
      onChange = transferProps.onChange,
      onSelectChange = transferProps.onSelectChange,
      style = transferProps.style,
      listStyle = transferProps.listStyle,
      operationStyle = transferProps.operationStyle,
      _transferProps$titles = transferProps.titles,
      titles = _transferProps$titles === void 0 ? [] : _transferProps$titles,
      _transferProps$operat = transferProps.operations,
      operations = _transferProps$operat === void 0 ? [] : _transferProps$operat,
      _transferProps$search = transferProps.searchPlaceholder,
      searchPlaceholder = _transferProps$search === void 0 ? [] : _transferProps$search,
      showSearch = transferProps.showSearch,
      filterOption = transferProps.filterOption,
      rowKey = transferProps.rowKey,
      onSearch = transferProps.onSearch,
      children = transferProps.children,
      oneWay = transferProps.oneWay,
      pagination = transferProps.pagination,
      showSelectAll = transferProps.showSelectAll,
      noDataContent = transferProps.noDataContent,
      footer = transferProps.footer;
  var transferLang = locale.getCompLangMsg({
    componentName: 'Transfer'
  });
  var transferPrefixCls = getPrefixCls(prefixCls, 'transfer', customPrefixcls);
  var cls = classNames(transferPrefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(transferPrefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(transferPrefixCls, "-customize-list"), !!children), _classNames), className);

  var _useState = useState(_filterInstanceProperty(selectedKeys).call(selectedKeys, function (key) {
    return targetKeys.indexOf(key) === -1;
  })),
      _useState2 = _slicedToArray(_useState, 2),
      sourceSelectedKeys = _useState2[0],
      setSourceSelectedKeys = _useState2[1];

  var _useState3 = useState(_filterInstanceProperty(selectedKeys).call(selectedKeys, function (key) {
    return targetKeys.indexOf(key) > -1;
  })),
      _useState4 = _slicedToArray(_useState3, 2),
      targetSelectedKeys = _useState4[0],
      setTargetSelectedKeys = _useState4[1];

  var leftActive = targetSelectedKeys.length > 0;
  var rightActive = sourceSelectedKeys.length > 0;
  var mergedPagination = !children && pagination;
  var leftTitle = titles[0] || transferLang.leftTitle;
  var rightTitle = titles[1] || transferLang.rightTitle;
  var leftPlaceholder = searchPlaceholder[0] || transferLang.searchPlaceholder[0];
  var rightPlaceholder = searchPlaceholder[1] || transferLang.searchPlaceholder[1];

  var setStateKeys = function setStateKeys(direction, keys) {
    if (direction === 'left') {
      setSourceSelectedKeys(typeof keys === 'function' ? keys(sourceSelectedKeys || []) : _toConsumableArray(keys));
    } else {
      setTargetSelectedKeys(typeof keys === 'function' ? keys(targetSelectedKeys || []) : _toConsumableArray(keys));
    }
  };

  var moveTo = function moveTo(direction) {
    var moveKeys = direction === 'right' ? sourceSelectedKeys : targetSelectedKeys; // 过滤出disable的选项

    var newMoveKeys = _filterInstanceProperty(moveKeys).call(moveKeys, function (key) {
      return !dataSource.some(function (data) {
        return !!(key === data.key && data.disabled);
      });
    });

    var newTargetKeys = direction === 'right' ? _concatInstanceProperty(newMoveKeys).call(newMoveKeys, targetKeys) : _filterInstanceProperty(targetKeys).call(targetKeys, function (targetKey) {
      return newMoveKeys.indexOf(targetKey) === -1;
    }); // 重置选择项

    var oppositeDirection = direction === 'right' ? 'left' : 'right';
    setStateKeys(oppositeDirection, []);
    handleSelectChange(oppositeDirection, []);

    if (onChange) {
      onChange(newTargetKeys, direction, newMoveKeys);
    }
  };

  var moveToLeft = function moveToLeft() {
    return moveTo('left');
  };

  var moveToRight = function moveToRight() {
    return moveTo('right');
  };

  var handleFilter = function handleFilter(direction, e) {
    var value = e.target.value;

    if (onSearch) {
      onSearch(direction, value);
    }
  };

  var handleLeftFilter = function handleLeftFilter(e) {
    return handleFilter('left', e);
  };

  var handleRightFilter = function handleRightFilter(e) {
    return handleFilter('right', e);
  };

  var handleClear = function handleClear(direction) {
    if (onSearch) {
      onSearch(direction, '');
    }
  };

  var handleLeftClear = function handleLeftClear() {
    return handleClear('left');
  };

  var handleRightClear = function handleRightClear() {
    return handleClear('right');
  };

  var onItemSelectAll = function onItemSelectAll(direction, selectedKeys, checkAll) {
    setStateKeys(direction, function (prevKeys) {
      var mergedCheckedKeys = [];

      if (checkAll) {
        var _context;

        //  全选
        mergedCheckedKeys = _toConsumableArray(new _Set(_concatInstanceProperty(_context = []).call(_context, _toConsumableArray(prevKeys), _toConsumableArray(selectedKeys))));
      } else {
        // 取消全选
        mergedCheckedKeys = _filterInstanceProperty(prevKeys).call(prevKeys, function (key) {
          return selectedKeys.indexOf(key) === -1;
        });
      }

      handleSelectChange(direction, mergedCheckedKeys);
      return mergedCheckedKeys;
    });
  };

  var onLeftItemSelectAll = function onLeftItemSelectAll(selectedKeys, checkAll) {
    return onItemSelectAll('left', selectedKeys, checkAll);
  };

  var onRightItemSelectAll = function onRightItemSelectAll(selectedKeys, checkAll) {
    return onItemSelectAll('right', selectedKeys, checkAll);
  };

  var onItemSelect = function onItemSelect(direction, selectedKey, checked) {
    var holder = direction === 'left' ? _toConsumableArray(sourceSelectedKeys) : _toConsumableArray(targetSelectedKeys);
    var index = holder.indexOf(selectedKey);

    if (index > -1) {
      _spliceInstanceProperty(holder).call(holder, index, 1);
    }

    if (checked) {
      holder.push(selectedKey);
    }

    handleSelectChange(direction, holder);
    setStateKeys(direction, holder);
  };

  var onLeftItemSelect = function onLeftItemSelect(selectedKey, checked) {
    return onItemSelect('left', selectedKey, checked);
  };

  var onRightItemSelect = function onRightItemSelect(selectedKey, checked) {
    return onItemSelect('right', selectedKey, checked);
  };

  var onRightItemRemove = function onRightItemRemove(selectedKeys) {
    setStateKeys('right', []);

    if (onChange) {
      onChange(_filterInstanceProperty(targetKeys).call(targetKeys, function (key) {
        return !_includesInstanceProperty(selectedKeys).call(selectedKeys, key);
      }), 'left', _toConsumableArray(selectedKeys));
    }
  };

  var handleSelectChange = function handleSelectChange(direction, holder) {
    if (!onSelectChange) return;

    if (direction === 'left') {
      onSelectChange(holder, targetSelectedKeys);
    } else {
      onSelectChange(sourceSelectedKeys, holder);
    }
  };

  var handleListStyle = function handleListStyle(listStyle, direction) {
    if (typeof listStyle === 'function') {
      return listStyle({
        direction: direction
      });
    }

    return listStyle;
  };

  var handleNoDataContent = function handleNoDataContent(noDataContent, direction) {
    if (typeof noDataContent === 'function') {
      return noDataContent({
        direction: direction
      });
    }

    var defaultContent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
      src: noDataImg,
      alt: transferLang.emptyTip,
      height: 96
    }), /*#__PURE__*/React.createElement("span", {
      className: "".concat(transferPrefixCls, "-list-body-not-found-tip")
    }, transferLang.emptyTip));
    return noDataContent || defaultContent;
  }; // 获取左右数据源


  var separateDataSource = function separateDataSource() {
    var leftDataSource = [];
    var rightDataSource = new Array(targetKeys.length);
    dataSource.forEach(function (record) {
      if (rowKey) {
        record.key = rowKey(record);
      }

      var indexOfKey = targetKeys.indexOf(record.key);

      if (indexOfKey !== -1) {
        rightDataSource[indexOfKey] = record;
      } else {
        leftDataSource.push(record);
      }
    });
    return {
      leftDataSource: leftDataSource,
      rightDataSource: rightDataSource
    };
  };

  var _separateDataSource = separateDataSource(),
      leftDataSource = _separateDataSource.leftDataSource,
      rightDataSource = _separateDataSource.rightDataSource;

  return /*#__PURE__*/React.createElement("div", {
    className: cls,
    style: style
  }, /*#__PURE__*/React.createElement(List, {
    prefixCls: "".concat(transferPrefixCls, "-list"),
    placeholder: leftPlaceholder,
    titleText: leftTitle,
    dataSource: leftDataSource,
    filterOption: filterOption,
    style: handleListStyle(listStyle, 'left'),
    checkedKeys: sourceSelectedKeys,
    handleFilter: handleLeftFilter,
    handleClear: handleLeftClear,
    onItemSelect: onLeftItemSelect,
    onItemSelectAll: onLeftItemSelectAll,
    render: render,
    showSearch: showSearch,
    renderList: children,
    disabled: disabled,
    direction: "left",
    showSelectAll: showSelectAll,
    pagination: mergedPagination,
    noDataContent: handleNoDataContent(noDataContent, 'left'),
    footer: footer
  }), /*#__PURE__*/React.createElement(Operation, {
    className: "".concat(transferPrefixCls, "-operation"),
    rightActive: rightActive,
    rightArrowText: operations[0],
    moveToRight: moveToRight,
    leftActive: leftActive,
    leftArrowText: operations[1],
    moveToLeft: moveToLeft,
    style: operationStyle,
    disabled: disabled,
    oneWay: oneWay
  }), /*#__PURE__*/React.createElement(List, {
    prefixCls: "".concat(transferPrefixCls, "-list"),
    placeholder: rightPlaceholder,
    titleText: rightTitle,
    dataSource: rightDataSource,
    filterOption: filterOption,
    style: handleListStyle(listStyle, 'right'),
    checkedKeys: targetSelectedKeys,
    handleFilter: handleRightFilter,
    handleClear: handleRightClear,
    onItemSelect: onRightItemSelect,
    onItemSelectAll: onRightItemSelectAll,
    onItemRemove: onRightItemRemove,
    render: render,
    showSearch: showSearch,
    renderList: children,
    disabled: disabled,
    direction: "right",
    showSelectAll: showSelectAll,
    pagination: mergedPagination,
    noDataContent: handleNoDataContent(noDataContent, 'right'),
    footer: footer,
    showRemove: oneWay
  }));
};

export default Transfer;